import Image from 'next/image';
import { useContext } from 'react';

import { DispatchEvents } from '../../../enums/dispatchEvent';
import { AppContext } from '../../../context/App/context';
import { bookAnAppointmentBackground } from '../../../definitions/book-an-appointment';
import CustomButton from '../../atoms/custom-button/custom-button';

export function BookAnAppointment() {
  const { state, dispatch } = useContext(AppContext);

  function handleOpenCalendly() {
    dispatch({
      type: DispatchEvents.DISPLAY_CALENDLY,
      payload: {
        ...state.calendlyProps,
        isOpen: true
      }
    });
  }

  return (
    <div className="w-full h-36 md:h-96 relative mt-12">
      <Image
        alt="book an appointment image"
        blurDataURL="/icons/blur-placeholder.png"
        layout="fill"
        objectFit="cover"
        placeholder="blur"
        src={bookAnAppointmentBackground}
      />
      <CustomButton
        buttonText="BOOK AN APPOINTMENT NOW! >"
        buttonStyle="absolute w-64 z-10 bottom-10 md:bottom-32 left-0 right-0 mx-auto bg-black/50"
        textStyle="text-white"
        handleClickButton={handleOpenCalendly}
      />
    </div>
  );
}

export default BookAnAppointment;
